import { ComponentType } from 'react';
import ErrorBoundary from './error-boundary';

type WithErrorBoundaryOptions = {
    withText?: boolean;
};

const withErrorBoundaryWrapper = <Props extends object>(
    Component: ComponentType<Props>,
    options: WithErrorBoundaryOptions = {}
) => {
    const { withText } = options;

    const WrappedComponent = (props: Props) => (
        <ErrorBoundary withText={withText}>
            <Component {...props} />
        </ErrorBoundary>
    );

    WrappedComponent.displayName = `withErrorBoundaryWrapper(${
        Component.displayName || Component.name || 'Component'
    })`;

    return WrappedComponent;
};

export default withErrorBoundaryWrapper;
